import React from 'react';
import { AppProviders } from '@maat/store-provider';
import { ErrorBoundary } from '@maat/components-errors';
import { AppContext } from '@maat/store-error';
import { AppRouter } from './AppRouter';
import { VersionWatcher } from './VersionWatcher';
import { UpdateMigrator } from './UpdateMigrator';
import { ReloadRequiredToast } from './ReloadRequiredToast';

// Read HERE — app source is where Vite inlines VITE_* — then provided to the
// singleton context so every remote sees them.
const oauth = {
    googleClientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,
    appleClientId: import.meta.env.VITE_APPLE_OAUTH_CLIENT_ID,
};

// Same pattern: the user-content translation key is inlined here.
const i18n = {
    translateApiKey: import.meta.env.VITE_GOOGLE_TRANSLATE_API_KEY,
};

// The MF host: it owns the whole provider stack and renders the active profile's
// remote. Its page boundary wraps every remote, tagged by active app.
export const App = () => (
    <AppProviders oauth={oauth} i18n={i18n}>
        <ErrorBoundary app={AppContext.Shell} variant="page" showDetails={import.meta.env.DEV}>
            <VersionWatcher />
            <UpdateMigrator />
            <ReloadRequiredToast />
            <AppRouter />
        </ErrorBoundary>
    </AppProviders>
);
